import { JobAgeKey, RemoteOptionKey } from '@/domain/job-details/components/header/header.types';

export const JobAgeHighlightMapping: Record<JobAgeKey, string> = {
  JOBS_POSTING_EARLY_APPLICANT_MARKER: 'job_tag_early_applicant',
  JOBS_POSTING_ACTIVELY_RECRUITING_MARKER: 'job_tag_actively_recruiting',
  JOBS_POSTING_LAST_CHANCE_MARKER: 'job_tag_last_chance_to_apply',
};
export const RemoteHighlightMapping: Record<RemoteOptionKey, string> = {
  JOBS_HYBRID_TAG: 'job_tag_hybrid',
  JOBS_REMOTE_TAG: 'job_tag_remote',
  REMOTE_OPTION_NON_REMOTE: 'job_tag_on_site',
};
